module.exports = __webpack_public_path__ + "static/08-1eed5a3d222e66c9051a51ee94e2da26.jpg";